/**
 * 初期タスクステップのデータ
 * 各ステップは以下のプロパティを持ちます：
 * @property {string} title - ステップのタイトル
 * @property {Array<string>} instructions - 指示内容のテキスト配列
 * @property {Array<string>} [listItems] - 箇条書きで表示する項目の配列 (オプション)
 * @property {string} [appealContent] - 強調して表示するコンテンツ (オプション)
 * @property {string} [buttonText] - ボタンのテキスト (デフォルト: '次へ')
 */
export const TaskStepParam = [
    {
        title: "篠原ダム、竹田調整池堰ITVカメラ確認を確認してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"]
    },
    {
        title: "ダム及び管内水力発電所の震度情報を確認してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"]
    },
    {
        title: "グループ長へ下記内容を報告してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"],
        listItems: [
            "地震発生時間",
            "対象地震観測所の震度",
            "臨時点検対象ダム名",
            "ITVカメラでの概略被災状況",
            "国土交通省 大分河川国道事務所への電話連絡の実施"
        ]
    },
    {
        title: "国土交通省 大分河川国道事務所へ「篠原ダム」の下記内容を電話連絡してください。",
        appealContent: "河川管理課 外線：0975-44-4167、携帯：090-8761-0261",
        instructions: ["電話連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"],
        listItems: [
            "地震発生時間",
            "対象地震観測所の震度",
            "臨時点検対象ダム名",
            "ITVカメラでの概略被災状況"
        ]
    },
    {
        title: "水力運営グループへ「篠原ダム」の下記内容をTeamsで報告してください",
        appealContent: "Teams連絡先：非常災害時等の情報共有（水力関係） 05 大分水力センター⇔水力運営グループ",
        listItems: [
          "地震発生時間",
          "対象地震観測所の震度",
          "臨時点検対象ダム名",
          "ITVカメラでの概略被災状況",
          "国土交通省への電話連絡の実施完了"
        ],
        instructions: ["Teamsで連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"]
    },
    {
        title: "発電所の出力確認をし、印刷して保存してください",
        instructions: ["印刷して保存が終わったら「次へボタン」をクリックし次の業務を実施してください"]
    },
    {
        title: "鮎川発電所・幸野発電所・畑発電所の遠隔監視装置を確認してください",
        instructions: [
            "※水力中給へ全ての発電運転状況を確認してください<br />また、鮎川発電所・幸野発電所・畑発電所が発電所の門扉(自動)操作を行っていた場合、水力中給へ連絡してください",
            "確認が終わったら「次へボタン」をクリックし次の業務を実施してください"
        ]
    },
    {
        title: "山下池堰の下記内容を確認してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"],
        listItems: [
            "地震計にて計測されたデータ(最大加速度(gal))が、25gal以下か",
            "斜面計測値は問題ないか"
        ],
    },
    {
        title: "丸田発電所・山下池堰挙動監視装置の挙動監視装置を確認してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"],
    },
    {
        title: "「direct」でニシコー情報共有にて発電出力と地震状況を共有してください",
        instructions: [
            "ニシコーが全発電所を巡視不可の場合、各取引先へ協力依頼を実施してください。合わせて運用補助業務指示書準備を実施してください。",
            "共有が終わったら「次へボタン」をクリックし次の業務を実施してください"
        ],
    },
    {
        title: "震度５弱以上を観測した発電所はITVカメラによる取水堰（Webカメラ設置箇所のみ）確認を実施してください",
        instructions: ["確認が終わったら「次へボタン」をクリックし次の業務を実施してください"],
    },
    {
        title: "以下のファイルを机に出してください",
        listItems: [
            "地震発生時の確認・行動・連絡マニュアル",
            "予防停止操作手順書",
            "管内発電所 臨時点検マニュアル"
        ],
        instructions: ["手順書やマニュアルの準備が終わったら「次へボタン」をクリックし次の業務を実施してください"],
    },
    {
        title: "精巧エンジニアリングへ電話連絡して下さい",
        listItems: [
            "吉野俊輔　電話番号：090-8295-9293、メールアドレス：yoshino@seikoeng.co.jp",
            "中塚吉和　電話番号：090-1977-3634、メールアドレス：nakatuka@seikoeng.co.jp",
        ],
        instructions: ["連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"],
    },
    {
        title: "第１報の本報告を開始",
        instructions: [
            "第1報速報および初期対応は完了しましたか？<br />完了している場合は「第１報 本報告開始ボタン」をクリックし次の業務を実施してください",
        ],
        buttonText: '第１報 本報告開始',
    }
];